import { useState } from "react";

import { PrimaryButton } from "~/components/Button";
import {
  GoogleIcon,
  ICalendarIcon,
  OutlookIcon,
  YahooIcon,
} from "~/components/Icons/CalendarIcons";
import { PlusIcon } from "~/components/Icons/PlusIcon";
import { Text } from "~/components/Text";
import type { AppointmentDetails } from "~/utils/appointment.utils.server";

interface ICalendarLinks {
  calendarLinks: NonNullable<AppointmentDetails["calendarLinks"]>;
}

export function CalendarLinks({ calendarLinks: { google, ical, outlook, yahoo } }: ICalendarLinks) {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="relative flex flex-col gap-sm" data-component="CalendarLinks">
      <PrimaryButton
        className="flex flex-row items-center gap-xs pl-sm"
        onPress={() => setIsOpen(!isOpen)}
      >
        <span>
          <Text i18nKey="Confirmation.AddToCalendar.title" />
        </span>
        <PlusIcon className="h-base w-base" />
      </PrimaryButton>
      {isOpen && (
        <div className="top-lg flex flex-col space-y-sm md:absolute">
          <CalendarLink href={google}>
            <GoogleIcon className="mr-xs" height="24" width="24" />
            <Text i18nKey="Confirmation.AddToCalendar.google" />
          </CalendarLink>

          <CalendarLink href={yahoo}>
            <YahooIcon className="mr-xs" height="24" width="24" />
            <Text i18nKey="Confirmation.AddToCalendar.yahoo" />
          </CalendarLink>

          <CalendarLink href={outlook}>
            <OutlookIcon className="mr-xs" height="24" width="24" />
            <Text i18nKey="Confirmation.AddToCalendar.outlook" />
          </CalendarLink>

          <CalendarLink href={ical}>
            <ICalendarIcon className="mr-xs fill-brand" height="24" width="24" />
            <Text i18nKey="Confirmation.AddToCalendar.calendar" />
          </CalendarLink>
          <div className="relative">
            <div className="absolute top-sm" data-iframe-height></div>
          </div>
        </div>
      )}
    </div>
  );
}

function CalendarLink({ children, ...props }: React.AnchorHTMLAttributes<HTMLAnchorElement>) {
  return (
    <a {...props} className="flex text-brand underline" rel="noreferrer noopener" target="_blank">
      {children}
    </a>
  );
}
